import React, { useState } from 'react'
import Layout from '../components/Layout'
import './CSS/Admin.css'
import Product from './admincom/Product';
import SignUp from './admincom/SignUp';
import Catagories from './admincom/Catagories';

const Admin = () => {

  const [product, setProduct] = useState(true);
  const [sign, setSign] = useState(false);
  const [cat, setCat] = useState(false);

  const handleButtonClick = (divNumber) => {
    if (divNumber === 1) {
      setProduct(true);
      setSign(false);
      setCat(false)
    } else if (divNumber === 2) {
      setProduct(false);
      setSign(true);
      setCat(false)
    }else if( divNumber === 3){
      setProduct(false)
      setSign(false)
      setCat(true)
    }
  };
  

  
  return (
    <Layout>
    <div className='a-main'>
      <button onClick={() => handleButtonClick(1)}>Products</button>
      <button onClick={() => handleButtonClick(2)}>SignUP</button>
      <button onClick={() => handleButtonClick(3)}>Catagories</button>
    </div>
    <div className='a-main mt-2'>

      {product &&  <Product/>}

      {sign &&   <SignUp/>}

      {cat && <Catagories/>}
      
    </div>
    </Layout>
  )
}

export default Admin
